export enum RightSidebarAliasesEnum {
	newWorkOrder = 'newWorkOrder',
	editWorkOrder = 'editWorkOrder',
	newRequest = 'newRequest',
	editRequest = 'editRequest',
	newIncident = 'newIncident',
	editIncident = 'editIncident',
	newAsset = 'newAsset',
	editAsset = 'editAsset',
	editFile = 'editFile',
	attachExisting = 'attachExisting',
	fileDetector = 'fileDetector',
	messages = 'messages',
}
